/**
 * Premier seamless sync for desktop / SPA.
 * Default ON. Build with VITE_PREMIER_SEAMLESS_SYNC=0 to restore ConflictReview as the default path.
 */
const viteFlag =
  typeof import.meta !== "undefined"
    ? (import.meta as ImportMeta & { env?: { VITE_PREMIER_SEAMLESS_SYNC?: string } }).env
        ?.VITE_PREMIER_SEAMLESS_SYNC
    : undefined;

export const PREMIER_SEAMLESS_SYNC = viteFlag !== "0" && viteFlag !== "false";
